import { render, staticRenderFns } from "./zhTabsSection.vue?vue&type=template&id=1299b061&scoped=true"
import script from "./zhTabsSection.vue?vue&type=script&lang=js"
export * from "./zhTabsSection.vue?vue&type=script&lang=js"
import style0 from "./zhTabsSection.vue?vue&type=style&index=0&id=1299b061&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1299b061",
  null
  
)

export default component.exports